// What each remuneration modal sends back once saved (`setModalDataReturn`),
// applied to the company's info: shared by the panel, which reads them one at
// a time, and by the batch of changes, which applies them in a row.

const withBenefits = (info, next) => ({
  ...info,
  bonusesAndAllowances: { ...info.bonusesAndAllowances, ...next },
});
const bonusesOf = (info) => info.bonusesAndAllowances?.bonuses ?? [];

const APPLY = {
  coefficients_updated: (info, change) => ({ ...info, coefficients: change.coefficients }),
  overtimes_updated: (info, change) => ({ ...info, overtimes: change.overtimes }),
  night_hours_updated: (info, change) => ({ ...info, nightHours: change.nightHours }),
  sunday_hours_updated: (info, change) => ({ ...info, sundayHours: change.sundayHours }),
  holiday_hours_updated: (info, change) => ({
    ...info,
    holidayHours: change.holidayHours,
    solidarityDayLabel: change.solidarityDayLabel ?? null,
    specialDayLabel: change.specialDayLabel ?? null,
  }),
  restaurant_ticket_updated: (info, change) =>
    withBenefits(info, { restaurant_ticket: change.restaurantTicket }),
  bonuses_and_allowances_added: (info, change) =>
    withBenefits(info, { bonuses: [...bonusesOf(info), change.bonusesAndAllowances] }),
  bonuses_and_allowances_updated: (info, change) =>
    withBenefits(info, {
      bonuses: bonusesOf(info).map((bonus) =>
        String(bonus._id) === String(change.bonusesAndAllowances._id) ? change.bonusesAndAllowances : bonus,
      ),
    }),
  bonuses_and_allowances_deleted: (info, change) =>
    withBenefits(info, {
      bonuses: bonusesOf(info).filter((bonus) => String(bonus._id) !== String(change.idBonusesAndAllowances)),
    }),
};

// The value each return must carry: a return without it changes nothing.
const PAYLOAD = {
  coefficients_updated: 'coefficients',
  overtimes_updated: 'overtimes',
  night_hours_updated: 'nightHours',
  sunday_hours_updated: 'sundayHours',
  holiday_hours_updated: 'holidayHours',
  restaurant_ticket_updated: 'restaurantTicket',
  bonuses_and_allowances_added: 'bonusesAndAllowances',
  bonuses_and_allowances_updated: 'bonusesAndAllowances',
  bonuses_and_allowances_deleted: 'idBonusesAndAllowances',
};

// The card or row a return lands on, as the panels register them.
export const REMUNERATION_SECTIONS = {
  coefficients_updated: 'coefficients',
  overtimes_updated: 'overtimes',
  night_hours_updated: 'nightHours',
  sunday_hours_updated: 'sundayHours',
  holiday_hours_updated: 'holidayHours',
  restaurant_ticket_updated: 'restaurantTicket',
  bonuses_and_allowances_added: 'bonuses',
  bonuses_and_allowances_updated: 'bonuses',
  bonuses_and_allowances_deleted: 'bonuses',
};

export const isRemunerationReturn = (change) => Boolean(change && APPLY[change.type] && change[PAYLOAD[change.type]]);

// `info` unchanged when `change` is not a remuneration return.
export const applyRemunerationReturn = (info, change) =>
  isRemunerationReturn(change) ? APPLY[change.type](info ?? {}, change) : info;
